import { TextButton } from '@/components/common/text-button';

import type { CommandType, Device } from '../types';
import { useCommandLifecycle } from '../use-command-lifecycle';

import styles from './command-banner.module.scss';

export type CommandBannerProps = {
  device: Device;
};

const TITLE: Record<CommandType, string> = {
  turn_on: 'Turn On Queued',
  turn_off: 'Turn Off Queued',
  stop_timer: 'Stop Timer Queued',
  schedule: 'Schedule Queued',
};

const SUBTITLE: Record<CommandType, string> = {
  turn_on: 'Device will turn on when it comes online.',
  turn_off: 'Device will turn off when it comes online.',
  stop_timer: 'Device will stop when it comes online.',
  schedule: 'Schedule will apply when the device comes online.',
};

/**
 * "Turn On Queued" banner shown on the device detail while a command is in flight
 * (story 101849 / Figma 2640-811881). Cancel is offered only while the command is still
 * Queued — once Digital Matter has acknowledged it (Delivered) it can no longer be pulled
 * back. Renders nothing when no command is pending.
 */
export function CommandBanner({ device }: CommandBannerProps) {
  const { pending, type, cancelable, cancel } = useCommandLifecycle(device);

  if (!pending || !type) return null;

  return (
    <div className={styles.banner} role="status" aria-live="polite">
      <div className={styles.text}>
        <span className={styles.title}>{TITLE[type]}</span>
        <span className={styles.subtitle}>{SUBTITLE[type]}</span>
      </div>
      {cancelable ? (
        <TextButton tone="danger" size="sm" onClick={cancel} className={styles.cancel}>
          Cancel
        </TextButton>
      ) : null}
    </div>
  );
}
